import tools from '@/sui/data/sheets/edit/tools'
import notes from '@/sui/data/sheets/edit/notes'

import beds from '@/sui/data/sheets/beds'
import go from '@/gojs/go'

const none = [{ index: 0, code: '', value: 'Aucun' }]

const fields = {
  establishmentType: 'establishmentType',
  maternityType: 'maternityType',
  hasMaternity: 'hasMaternity'
}

function checkEntrancesAndHospitBounds (mbeds, entrances, field, result, sheet) {
  const maxField = sheet[mbeds.watchedBeds(field)]
  if (maxField == null) {
    return
  }

  const max = parseInt(maxField, 10)
  const numericChecks = [
    {
      field: mbeds.hospiDays(field),
      bounds: {
        upper: max * 100
      },
      message: {
        above: `Le nombre de journées d'hospitalisation complètes semble trop élevé
par rapport au nombre de lits surveillés et à la durée de la surveillance`,
        type: 'warning'
      }
    }
  ]
  if (entrances) {
    numericChecks.push(
      {
        field: mbeds.entrances(field),
        bounds: {
          upper: max * 100
        },
        message: {
          above: `Le nombre d'admissions semble trop élevé par rapport au
nombre de lits surveillés et à la durée de la surveillance`,
          type: 'warning'
        }
      }
    )
  }
  notes.checkNumerics(result, sheet, numericChecks)
}

function checkUnitType (mbeds, type, result, sheet, t3) {
  if (type.type !== 'had') {
    const totalField = mbeds.totalBeds(type.field)
    const totalBeds = {
      value: sheet[totalField],
      text: `nombre de lits total (tableau 2)`,
      note: result[totalField]
    }

    if (t3) {
      const watchedField = mbeds.watchedBeds(type.field)
      const watchedBeds = {
        value: sheet[watchedField],
        text: `nombre de lits surveillés (tableau 3)`,
        note: result[watchedField]
      }

      notes.compareNumerics(watchedBeds, totalBeds)
      checkEntrancesAndHospitBounds(
        mbeds, type.skipEntrances !== true, type.field, result, sheet
      )
    }
  }

  if (type.list != null && type.list.length > 0) {
    checkUnitTypeList(mbeds, type, result, sheet, t3)
  }
}

function checkUnicity (value, field, list, index, note, tooltip) {
  const v = value[field]
  if (v != null && list.findIndex(e => e[field] === v) !== index) {
    const n = note[field]
    n.type = 'error'
    n.tooltip = tooltip
  }
}

function checkUnitTypeUnicityAndCollectCounts (mbeds, type, result, sheet) {
  const collect = {
    total: 0,
    values: {}
  }
  const detailField = mbeds.detailBeds(type.field)
  const detail = sheet[detailField]
  const notes = result[detailField]
  for (let i = 0; i !== detail.length; ++i) {
    const d = detail[i]
    const value = d[mbeds.bedCount]
    if (value != null) {
      const v = parseInt(value, 10)
      collect.total += v
      collect.values[d.unitType] = {
        value: v,
        note: notes[i]
      }
    }
    checkUnicity(
      d, 'unitType', detail, i, notes[i],
      `Chaque spécialité ne doit être présente qu'une seule fois`
    )
  }

  return collect
}

function setNote (note, type, tooltip) {
  note.type = type
  note.tooltip = tooltip
}

function setNotes (notes, getter, type, tooltip) {
  for (let i in notes) {
    const n = notes[i]
    const note = getter(n)
    setNote(note, type, tooltip)
  }
}

function incrementIfNecessary (target, secondary, sheet, fieldIn, fieldOut) {
  const count = sheet[fieldIn]
  if (count != null) {
    const value = parseInt(count, 10)
    target[fieldOut] += value
    secondary[fieldOut] += value
  }
}

function checkFields (mbeds) {
  const result = [
    { field: mbeds.watchedBeds, text: 'de lits surveillés' },
    { field: mbeds.hospiDays, text: `de journées d'hospitalisation` },
    { field: mbeds.entrances, text: `d'admissions` },
    { field: mbeds.dialysisCount, text: 'de séances de dialyse' }
  ]
  return result
}

function buildCollector (mbeds) {
  const result = {
    notes: []
  }
  checkFields(mbeds).forEach(({ field }) => { result[field('')] = 0 })
  return result
}

function checkSubfields (mbeds, type, result, sheet, counts, detail) {
  const data = checkListAndCollect(
    mbeds, type.subfields, result, sheet, 'code', e => e.field, false
  )

  checkWatchedBeds(mbeds, data, counts, n => result[mbeds.watchedBeds(n)])
  checkSumFields(
    mbeds, type, result, sheet, data, 'spécialité', f => n => result[f.field(n)]
  )

  checkFields(mbeds).forEach(
    f => {
      const field = f.field('')
      for (let t in detail) {
        const value = data.collect[t]
        if (value == null) {
          continue
        }
        const d = detail[t]
        const vc = value[field]
        const vd = d[field]
        if (vc < vd) {
          const spe = `Le nombre ${f.text} pour cette spécialité
(${vc}) doit être supérieur ou égal au cumul du nombre ${f.text} par
service (${vd})`
          setNotes(value.notes, n => result[f.field(n)], 'error', spe)

          const uf = `Le cumul du nombre ${f.text} par service
(${vd}) doit être inférieur ou égal au nombre ${f.text} pour
cette spécialité (${vc})`
          setNotes(d.notes, n => n[f.field('')], 'error', uf)
        }
      }
    }
  )
}

function checkListAndCollect (
  mbeds, list, result, sheet, unitTypeField, getField, targetItem, notes
) {
  const total = buildCollector(mbeds)
  const collect = {}

  for (let i = 0; i !== list.length; ++i) {
    const item = list[i]
    const unitType = item[unitTypeField]

    if (unitType == null) {
      continue
    }

    if (collect[unitType] == null) {
      collect[unitType] = buildCollector(mbeds)
    }

    const target = targetItem ? item : sheet
    const field = getField(item)
    const b = target[mbeds.watchedBeds(field)]
    const sn = notes != null ? notes[i] : field

    const watchedBeds = b != null ? parseInt(b, 10) : 0
    if (watchedBeds !== 0) {
      const v = collect[unitType]
      v.notes.push(sn)
      total.notes.push(sn)
      checkFields(mbeds).forEach(
        (f) => {
          incrementIfNecessary(v, total, target, f.field(field), f.field(''))
        }
      )
    }

    const boundsNote = notes != null ? sn : result
    checkEntrancesAndHospitBounds(
      mbeds, item.skipEntrances !== true, field, boundsNote, target
    )
  }
  return {
    total: total,
    collect: collect
  }
}

function checkWatchedBeds (mbeds, data, counts, note) {
  const watchedBedsField = mbeds.watchedBeds('')
  for (let t in data.collect) {
    const value = data.collect[t]
    const count = counts.values[t]
    const sum = value[watchedBedsField]
    if (count != null && sum > count.value) {
      const tooltip = `Le nombre total de lits pour la spécialité
${t} (${count.value}, tableau 2) doit être supérieur au cumul du nombre de lits surveillés
pour cette spécialité (${sum}, tableau 3)`
      setNotes(value.notes, note, 'error', tooltip)
      setNote(count.note[mbeds.bedCount], 'error', tooltip)
    }
  }
}

function checkSumFields (mbeds, type, result, sheet, data, group, getNote) {
  checkFields(mbeds).forEach(
    f => {
      const maxField = sheet[f.field(type.field)]
      const max = maxField != null ? parseInt(maxField, 10) : null
      if (max != null && data.total[f.field('')] > max) {
        const disc = `Le nombre ${f.text} pour cette discipline
(${max}) doit être supérieur ou égal au cumul du nombre ${f.text} par ${group}
(${data.total[f.field('')]})`
        setNote(result[f.field(type.field)], 'error', disc)

        const spe = `Le cumul du nombre ${f.text} par ${group}
(${data.total[f.field('')]}) doit être inférieur ou égal au nombre ${f.text}
pour cette discipline (${max})`
        setNotes(data.total.notes, getNote(f), 'error', spe)
      }
    }
  )
}

function checkSurveillanceFields (mbeds, type, result, sheet, counts) {
  const field = mbeds.detailSurveillance(type.field)
  const surveillance = sheet[field]
  const notes = result[field]
  const data = checkListAndCollect(
    mbeds, surveillance, result, sheet, 'unitType', e => '', true, notes
  )
  checkWatchedBeds(mbeds, data, counts, n => n[mbeds.watchedBeds('')])
  checkSumFields(
    mbeds, type, result, sheet, data, 'service', f => n => n[f.field('')]
  )

  return data.collect
}

function checkUnitTypeList (mbeds, type, result, sheet, t3) {
  const totalCounts = checkUnitTypeUnicityAndCollectCounts(
    mbeds, type, result, sheet
  )
  const totalField = mbeds.totalBeds(type.field)
  const total = sheet[totalField]
  const totalNote = result[totalField]
  const totalValue = total != null ? parseInt(total, 10) : null
  if (totalValue != null && totalCounts.total > totalValue) {
    const tooltip = `Le nombre total de lits (${totalValue}) doit être
supérieur ou égal à la somme du nombre de lits par spécialité
(${totalCounts.total})`
    setNote(totalNote, 'error', tooltip)
    setNotes(totalCounts.values, n => n.note[mbeds.bedCount], 'error', tooltip)
  }

  if (t3) {
    const collect = checkSurveillanceFields(mbeds, type, result, sheet, totalCounts)
    if (type.subfields != null && type.subfields.length > 0) {
      checkSubfields(mbeds, type, result, sheet, totalCounts, collect)
    }
  }
}

function checkValues (mbeds, types, result, sheet, t3) {
  types.forEach(
    (u) => {
      checkUnitType(mbeds, u, result, sheet, t3)
    }
  )
}

function checkAllValues (mbeds, result, sheet, t3) {
  checkValues(mbeds, mbeds.adTypes, result, sheet, t3)
  checkValues(mbeds, mbeds.pedTypes, result, sheet, t3)
  checkValues(mbeds, mbeds.neoTypes, result, sheet, t3)
  checkValues(mbeds, mbeds.mixTypes, result, sheet, t3)
}

function numericField (
  field, digits, title, tooltip, optional, accentuated, ignore
) {
  return {
    type: 'numeric',
    field: field,
    accentuated: accentuated,
    buildContext: tools.buildContext,
    config: {
      optional: optional,
      digits: digits,
      title: title,
      tooltip: tooltip
    },
    ignore: ignore
  }
}

function unitTypeField (unitList) {
  return {
    type: 'list',
    field: 'unitType',
    buildContext: tools.buildContext,
    config: {
      title: 'Spécialité',
      values: none.concat(unitList),
      placeholder: 'Taper quelques lettres de la spécialité...',
      tooltip: `Taper quelques lettres pour rechercher la spécialité :
<span class="key">ped r</span> pour la réanimation pédiatrique,
<span class="key">ad med d</span> pour la dermatologie, etc.`,
      defaultValue: 0
    },

    pop: function (e) {
      return e.unitType == null || e.unitType === ''
    }
  }
}

function ignoreFunction (field, ignoredValue) {
  return function (d) {
    const value = d != null ? d[field] : null
    return value == null || value === ignoredValue
  }
}

function ignoreNumericFunction (field) {
  return ignoreFunction(field, '0')
}

function unitTotalBeds (mbeds, field, name, type, year) {
  const last = `${year - 1}`
  if (type !== 'had') {
    return [
      numericField(
        mbeds.totalBeds(field),
        4,
        'Nombre de lits total',
        `Nombre de lits total pour les services ${name}.`,
        true,
        true
      )
    ]
  } else {
    return [
      numericField(
        mbeds.activeQueue(field),
        4,
        `File active moyenne en ${last}`,
        `Nombre moyen de patients par jour sur l'année ${last}.`,
        true,
        true
      ),

      numericField(
        mbeds.hospiDays2018(field),
        7,
        `Journées d'hospitalisation en ${last}`,
        `Journées d'hospitalisation en ${last}`,
        true,
        true
      )
    ]
  }
}

function unitDetailBeds (mbeds, field, title, link, unitList) {
  const totalField = mbeds.totalBeds(field)
  return {
    type: 'array',
    field: mbeds.detailBeds(field),
    ignore: function (d) {
      return d == null || d[totalField] == null || d[totalField] === '0'
    },

    config:
    {
      title: `SPÉCIALITÉ ${link} ${title} N°`,
      fields: [
        unitTypeField(unitList),
        numericField(
          mbeds.bedCount, 4, 'Nombre de lits',
          'Nombre de lits pour cette spécialité',
          false, false, ignoreFunction('unitType', '')
        )
      ]
    }
  }
}

function unitBeds (mbeds, types, year) {
  const result = []
  const defaultLink = 'DE '
  for (let i in types) {
    const t = types[i]
    result.push(...unitTotalBeds(mbeds, t.field, t.tooltip, t.type, year))
    if (t.list != null) {
      const link = t.link != null ? t.link : defaultLink
      result.push(unitDetailBeds(mbeds, t.field, t.title, link, t.list))
    }
  }
  return result
}

function unitFields (mbeds, types) {
  const result = []

  const defaultLink = 'DE '
  for (let i in types) {
    const t = types[i]
    result.push(
      ...unitTotal(
        mbeds, t.field, t.tooltip, t.type, titleFieldsTotal(mbeds).get(t.type)
      )
    )
    if (t.subfields != null) {
      for (let j in t.subfields) {
        const st = t.subfields[j]
        result.push(
          ...unitTotal(
            mbeds, st.field, st.tooltip, st.type,
            titleFieldsSurveillance(mbeds).get(st.type), t.field
          )
        )
      }
    }
    if (t.list != null) {
      const link = t.link != null ? t.link : defaultLink
      result.push(
        unitArray(mbeds, t.field, t.tooltip, t.title, link, t.type, t.list)
      )
    }
  }
  return result
}

function unitArray (mbeds, field, name, title, link, type, list) {
  const ignoreField = titleFieldsSurveillance(mbeds).get(type)
  const ignore = ignoreNumericFunction(ignoreField(field))
  const arrayIgnore = ignoreFunction('unitType', '')

  const fields = [
    unitTypeField(list)
  ].concat(...unit(mbeds, '', name, type, true, arrayIgnore, false))

  return {
    type: 'array',
    field: mbeds.detailSurveillance(field),
    ignore: ignore,
    config: {
      title: `SERVICE ${link} ${title} N°`,
      fields: fields
    }
  }
}

function unitTotal (mbeds, field, name, type, ignoreField, ref) {
  const ignore = ignoreNumericFunction(
    ignoreField(
      ref != null ? ref : field
    )
  )
  return unit(mbeds, field, name, type, false, ignore, true)
}

function unit (mbeds, field, name, type, uf, ignore, accentuated) {
  const watchedField = mbeds.watchedBeds(field)
  const activeQField = mbeds.activeQueueSurveillance(field)
  const result = []

  const i = uf ? ignore : ignoreNumericFunction(
    type === 'had' ? activeQField : watchedField
  )
  if (uf) {
    result.push(
      {
        field: mbeds.uf(field),
        type: 'text',
        buildContext: tools.buildContext,
        accentuated: accentuated,
        config: {
          title: 'UF / site',
          placeholder: 'UF, site...',
          tooltip: `Remplir ce champ pour distinguer vos résultats
par entités : nom de l'UFs, du site, ...`
        },
        ignore: i
      }
    )
  }

  const unit = uf ? 'ce service' : 'les services'
  if (type !== 'had') {
    result.push(
      numericField(
        watchedField, 4, 'Nombre de lits surveillés',
        `Nombre de lits surveillés pour ${unit} ${name} pendant
les 3 mois de surveillance.`, false, accentuated, ignore
      )
    )
    result.push(
      numericField(
        mbeds.entrances(field), 7, `Nombre d'admissions surveillées`,
        `Nombre d'admissions pour ${unit} ${name} pendant les 3
mois de surveillance.`, false, accentuated, i
      )
    )
  } else {
    result.push(
      numericField(
        activeQField, 4,
        'File active moyenne pendant la surveillance',
        'Nombre moyen de patients par jour pendant les 3 mois de surveillance',
        false, accentuated, ignore
      )
    )
  }

  if (type !== 'dia') {
    result.push(
      numericField(
        mbeds.hospiDays(field), 7,
        `Nombre de journées d'hospitalisation des patients surveillés`,
        `Nombre de journées d'hospitalisation pour ${unit}
${name} pendant les 3 mois de surveillance.`, false, accentuated, i
      )
    )
  } else {
    result.push(
      numericField(
        mbeds.dialysisCount(field), 7,
        `Nombre de séances de dialyse surveillées`,
        `Nombre de séances de dialyse pour ${unit}
${name} pendant les 3 mois de surveillance.`, false, accentuated, i
      )
    )
  }

  return result
}

function unitTitles (types, fields, subfields) {
  const result = []
  for (let i in types) {
    const t = types[i]
    const f = fields.get(t.type)
    result.push(
      {
        text: `${t.title}`,
        type: 'subtitle-alt',
        start: f(t.field),
        hiddenWhenFieldIgnored: true
      }
    )
    if (subfields && t.subfields != null) {
      for (let j in t.subfields) {
        const st = t.subfields[j]
        const sf = fields.get(st.type)
        result.push(
          {
            text: `${st.title}`,
            type: 'subtitle-sub',
            start: sf(st.field),
            hiddenWhenFieldIgnored: true
          })
      }
    }
  }
  return result
}

function titleFieldsTotal (mbeds) {
  return {
    base: mbeds.totalBeds,
    dia: mbeds.totalBeds,
    had: mbeds.activeQueue,

    get (type) {
      return type == null ? this.base : this[type]
    }
  }
}

function titleFieldsSurveillance (mbeds) {
  return {
    base: mbeds.watchedBeds,
    dia: mbeds.watchedBeds,
    had: mbeds.activeQueueSurveillance,

    get (type) {
      return type == null ? this.base : this[type]
    }
  }
}

function flasks2018 (optional, field) {
  return {
    type: 'numeric',
    field: field,
    accentuated: true,
    buildContext: tools.buildContext,
    config: {
      digits: 7,
      optional: optional,
      title: `Flacons d'hémocultures utilisés pour 2018 sur tout l'établissement`,
      tooltip: `Nombre de <strong>flacons</strong> d'hémocultures utilisés
pour toute l'année 2018 pour l'établissement de santé.`
    }
  }
}

function flasks2019 (optional, field) {
  return {
    type: 'numeric',
    field: field,
    accentuated: true,
    buildContext: tools.buildContext,
    config: {
      digits: 7,
      optional: optional,
      title: `Flacons d'hémocultures utilisés pendant les 3 mois
sur tout l'établissement`,
      tooltip: `Nombre de <strong>flacons</strong> d'hémocultures utilisés
pendant la période des 3 mois d'enquêtes pour tout l'établissement de santé.`
    }
  }
}

function titles (year) {
  const mbeds = beds[year]
  return {
    etb: {
      text: 'ÉTABLISSEMENT',
      type: 'title',
      start: 'establishmentStatus'
    },

    descr: {
      text: `DESCRIPTION DE L'ÉTABLISSEMENT`,
      type: 'title',
      start: mbeds.totalBeds('adRea')
    },

    beds: [
      {
        text: 'ADULTE',
        type: 'title-alt',
        start: mbeds.totalBeds('adRea')
      },
      ...unitTitles(mbeds.adTypes, titleFieldsTotal(mbeds)),
      {
        text: 'PÉDIATRIE',
        type: 'title-alt',
        start: mbeds.totalBeds('pedRea')
      },
      ...unitTitles(mbeds.pedTypes, titleFieldsTotal(mbeds)),
      {
        text: 'NÉONATALOGIE',
        type: 'title-alt',
        start: mbeds.totalBeds('neoRea')
      },
      ...unitTitles(mbeds.neoTypes, titleFieldsTotal(mbeds)),
      {
        text: 'MIXTE PÉDIATRIE + NÉONATALOGIE',
        type: 'title-alt',
        start: mbeds.totalBeds('mixRea')
      },
      ...unitTitles(mbeds.mixTypes, titleFieldsTotal(mbeds))
    ]
  }
}

const common = {
  status: {
    type: 'list',
    field: 'establishmentStatus',
    buildContext: tools.buildContext,
    accentuated: true,
    config: {
      title: `Statut de l'établissement`,
      displayValue: true,
      placeholder: '',
      tooltip: '',
      values: [
        { code: 1, value: '1. Public' },
        {
          code: 2,
          value: `2. ESPIC - Établissement de Santé Privé d'Intérêt Collectif`
        },
        { code: 3, value: '3. Privé' }
      ]
    }
  },

  type: {
    type: 'list',
    field: fields.establishmentType,
    buildContext: tools.buildContext,
    accentuated: true,
    config: {
      title: `Type d'établissement`,
      displayValue: true,
      placeholder: `Taper quelques lettres du type d'établissement...`,
      tooltip: `Taper quelques lettres du type d'établissement :
<span class="key">chr</span> pour un CHR/CHRU, <span class="key">eh</span>
pour un EHPAD indépendant...`,
      values: [
        {
          code: 1,
          value: 'CHRU/CHR - Centre Hospitalier Régional'
        },
        {
          code: 2,
          value: 'CH - Centre Hospitalier'
        },
        {
          code: 3,
          value: 'CH (ex-HL) - Centre Hospitalier, ex-hopital local'
        },
        {
          code: 4,
          value: 'HA - Établissement de santé relevant du service de santé des armées'
        },
        {
          code: 5,
          value: 'CLCC - Centre de Lutte Contre le Cancer'
        },
        {
          code: 6,
          value: 'Clinique MCO - Établissement de Soins de Courte Durée'
        },
        {
          code: 7,
          value: 'SSR - Établissement de santé privé autorisés en SSR'
        },
        {
          code: 8,
          value: 'SLD - Établissement de Soins de Longue Durée'
        },
        {
          code: 9,
          value: 'PSY - Centre Hospitalier spécialisé dans la Lutte contre les Maladies Mentales'
        },
        {
          code: 10,
          value: 'HAD - Hospitalisation à domicile'
        },
        {
          code: 11,
          value: 'DIA - Centre de dialyse'
        },
        {
          code: 12,
          value: 'EHP - EHPAD indépendant'
        }
      ]
    }
  },

  hasMaternity: tools.merge(
    tools.cfg.list(
      fields.hasMaternity, `L'établissement possède-t-il une maternité ?`, go.fields.yesNoUnknown
    ),
    {
      accentuated: true
    }
  ),

  maternityType: {
    type: 'list',
    field: fields.maternityType,
    buildContext: tools.buildContext,
    accentuated: true,
    ignore: (d) => d.hasMaternity !== 1,
    config: {
      title: `Type de maternité`,
      displayValue: true,
      placeholder: `Taper le type de maternité...`,
      tooltip: `Taper le type de maternité...`,
      values: [
        {
          code: 1,
          value: `Type 1 - Service d'obstétrique`
        },
        {
          code: 2,
          value: `Type 2a - Service d'obstétrique et de néonatalogie sur le même site`
        },
        {
          code: 3,
          value: `Type 2b - Service d'obstétrique, de néonatalogie et de soins intensifs néonatal sur le même site`
        },
        {
          code: 4,
          value: `Type 3 - Service d'obstétrique, de néonatalogie, de soins intensifs néonatal et de réanimation néonatale sur le même site`
        }
      ]
    }
  },

  beds: function (year) {
    const y = `${year}`
    const mbeds = beds[y]
    return [
      ...unitBeds(mbeds, mbeds.adTypes, year),
      ...unitBeds(mbeds, mbeds.pedTypes, year),
      ...unitBeds(mbeds, mbeds.neoTypes, year),
      ...unitBeds(mbeds, mbeds.mixTypes, year)
    ]
  }
}

function current (year) {
  const fields = [
    common.status,
    common.type
  ]

  if (year >= 2022) {
    fields.push(
      common.hasMaternity,
      common.maternityType
    )
  }

  fields.push(...common.beds(year))
  const t = titles(`${year}`)
  const result = {
    titles: [
      t.etb,
      t.descr,
      ...t.beds
    ],

    fields: fields,

    buildNotes: function (result, sheet) {
      checkAllValues(beds[`${year}`], result, sheet, false)
      return result
    }
  }
  return result
}

function titles2019 () {
  const t2019 = titles('2019')
  const mbeds = beds['2019']
  return [
    {
      text: 'TABLEAU 1',
      type: 'tab',
      start: 'establishmentStatus'
    },
    t2019.etb,
    {
      text: 'DONNÉES HÉMOCULTURES',
      type: 'title',
      start: 'flasks2018'
    },
    {
      text: 'TABLEAU 2',
      type: 'tab',
      start: mbeds.totalBeds('adRea')
    },
    t2019.descr,
    ...t2019.beds,
    {
      text: 'TABLEAU 3',
      type: 'tab',
      start: mbeds.watchedBeds('adRea')
    },
    {
      text: 'ACTIVITÉ PENDANT LA PÉRIODE DE SURVEILLANCE',
      type: 'title',
      start: mbeds.watchedBeds('adRea')
    },
    {
      text: 'ADULTE',
      type: 'title-alt',
      start: mbeds.watchedBeds('adRea')
    },
    ...unitTitles(mbeds.adTypes, titleFieldsSurveillance(mbeds), true),
    {
      text: 'PÉDIATRIE',
      type: 'title-alt',
      start: mbeds.watchedBeds('pedRea')
    },
    ...unitTitles(mbeds.pedTypes, titleFieldsSurveillance(mbeds), true),
    {
      text: 'NÉONATALOGIE',
      type: 'title-alt',
      start: mbeds.watchedBeds('neoRea')
    },
    ...unitTitles(mbeds.neoTypes, titleFieldsSurveillance(mbeds)),
    {
      text: 'MIXTE PÉDIATRIE + NÉONATALOGIE',
      type: 'title-alt',
      start: mbeds.watchedBeds('mixRea')
    },
    ...unitTitles(mbeds.mixTypes, titleFieldsSurveillance(mbeds))
  ]
}
export default {
  '2019': {
    titles: titles2019(),

    fields: [
      common.status,
      common.type,
      tools.merge(
        flasks2018(false, 'flasks2018'),
        {
          ignore: function (d) {
            return d == null || d[fields.establishmentType] === 10
          }
        }
      ),

      tools.merge(
        flasks2019(false, 'flasks2019'),
        {
          ignore: function (d) {
            return d == null || d[fields.establishmentType] === 10
          }
        }
      ),

      tools.merge(
        flasks2018(true, 'hadFlasks2018'),
        {
          ignore: function (d) {
            return d == null || d[fields.establishmentType] !== 10
          }
        }
      ),

      tools.merge(
        flasks2019(true, 'hadFlasks2019'),
        {
          ignore: function (d) {
            return d == null || d[fields.establishmentType] !== 10
          }
        }
      ),

      ...common.beds(2019),
      ...unitFields(beds['2019'], beds['2019'].adTypes),
      ...unitFields(beds['2019'], beds['2019'].pedTypes),
      ...unitFields(beds['2019'], beds['2019'].neoTypes),
      ...unitFields(beds['2019'], beds['2019'].mixTypes)
    ],

    buildNotes: function (result, sheet) {
      checkAllValues(beds['2019'], result, sheet, true)
      return result
    }
  },

  '2020': current(2020),
  '2021': current(2021),
  '2022': current(2022),
  '2023': current(2023),
  '2024': current(2024),
  '2025': current(2025),
  '2026': current(2026)
}
